import { CfBannerDownloadAppProps } from "../types";
import { CfImageProps } from "components/Image/types";
import { convertCfAllImgProps } from "utilities/cfPropTypes/cfBackground";
import BannerDownloadApp from "..";
import React from "react";

export const convertCfBannerDownloadAppProps = ({
  imageIconApp,
  title,
  text,
  buttonLabel,
  buttonLink,
}: CfBannerDownloadAppProps) => {
  const props = {
    imageIconApp: convertCfAllImgProps(imageIconApp[0] as CfImageProps),
    title,
    text: text?.text,
    buttonLink,
    buttonLabel,
  };
  return props;
};

const CfBannerDownloadApp = (props: CfBannerDownloadAppProps) => {
  return <BannerDownloadApp {...convertCfBannerDownloadAppProps(props)} />;
};

export default CfBannerDownloadApp;
